import Vue from 'vue'
import Router from 'vue-router'
import MainMenu from '@/components/MainMenu'
import ServerRoom from '@/components/ServerRoom'
import VueClipboard from 'vue-clipboard2'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueCarousel from 'vue-carousel'
import Scrollspy from 'vue2-scrollspy'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
import vueHeadful from 'vue-headful'

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'MainMenu',
      component: MainMenu
    },
    {
      path: '/s/:id',
      name: 'ServerRoom',
      component: ServerRoom
    },
    {
      path:'/',
      redirect: {name:'MainMenu'}
    },
    {
      path:'/*',
      redirect: '/s/page-not-found'
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-121791202-2',
  checkDuplicatedScript: true,
  router
})

Vue.component('vue-headful', vueHeadful)
Vue.use(VueLazyload)
Vue.use(Scrollspy)
Vue.use(VueCarousel)
Vue.use(VueClipboard)
Vue.use(Router)
Vue.use(Vuetify, {
  theme: {
    lightGray: "#cecece",
    black: "#000000"
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js